import { Link } from "react-router-dom";

interface BlogCardProps {
  id: string;
  title: string;
  date: string;
}

const BlogCard: React.FC<BlogCardProps> = ({ id, title, date }) => {
  return (
    <div className="border p-4 rounded-md shadow-md bg-white text-black">
      <h2 className="text-xl font-bold">{title}</h2>
      <p className="text-gray-600 text-sm">{date}</p>
      <Link to={`/blog/${id}`} className="text-blue-500 hover:underline">
        Devamını Oku →
      </Link>
    </div>
  );
};

export default BlogCard;
